import React, { useEffect, useState, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import ChatWidget from "../component/ChatWidget";
import AttractiveScrollButton from "../component/AttractiveScrollButton";
import Loader from "../component/Loader";
import { useDispatch, useSelector } from "react-redux";
import { getMaintenanceSettings } from "../Redux/Slice/maintenance.slice";

const Home = lazy(() => import("../pages/Home"));
const Login = lazy(() => import("../pages/Login"));
const TermsCondition = lazy(() => import("../component/TermsOfService/TermsCOndition"));
const PrivacyPolacy = lazy(() => import("../component/PrivacyPolacy/PrivacyPolacy"));
const Products = lazy(() => import("../pages/Products"));
const Platforms = lazy(() => import("../pages/Platforms"));
const Contact = lazy(() => import("../pages/Contact"));
const About = lazy(() => import("../pages/About"));
const Profile = lazy(() => import("../profile/Profile"));
const EditProfile = lazy(() => import("../profile/EditProfile"));
const DeleteAccount = lazy(() => import("../profile/DeleteAccount"));
const Orders = lazy(() => import("../profile/Orders"));
const Downloads = lazy(() => import("../profile/Downloads"));
const GameDetails = lazy(() => import("../pages/GameDetails"));
const Bundles = lazy(() => import("../pages/Bundles"));
const Cart = lazy(() => import("../pages/Cart"));
const Wishlist = lazy(() => import("../pages/Wishlist"));
const Blog = lazy(() => import("../component/Blog"));
const Faqs = lazy(() => import("../component/Faqs/Faqs"));
const NotFound = lazy(() => import("../Admin/NotFound"));
const DiscountGamesPage = lazy(() => import("../pages/DiscountGamesPage"));
const Maintenance = lazy(() => import("../pages/Maintenance"));

// const stripePromise = loadStripe("pk_test_51RlOu04MsbsH6KuURrRtTgj0lZCjFnmdn5A64CpHOHaPl8UwFGlX6jsYe9K9x4XUUSOIeUSisEM3aV5lriLPEw0300n0menKM3");

// Create a wrapper for Payment with Elements
// const PaymentWithStripe = (props) => (
//   <Elements stripe={stripePromise}>
//     <Payment {...props} />
//   </Elements>
// );

const UserRouts = () => {
  const dispatch = useDispatch();
  const { maintenance } = useSelector((state) => state.maintenance);
  const role = localStorage.getItem("role");

  // const userId = localStorage.getItem("ottuserId");
  const location = useLocation();
  const hideHeaderFooter = location.pathname === "/login" || location.pathname === "/maintenance";
  // const [detailsPage, setDetailsPage] = useState(false);

  // useEffect(() => {
  //   setDetailsPage(location.pathname.includes("/gamedetails"));
  // }, [location.pathname]);
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    dispatch(getMaintenanceSettings());
  }, [dispatch, location.pathname]);

  const isMaintenanceActive = maintenance?.isActive && (!maintenance?.completionTime || new Date(maintenance.completionTime) > new Date());

  if (isMaintenanceActive && location.pathname !== "/login" && role !== "superadmin") {
    return (
      <Routes>
        <Route path="*" element={<Maintenance />} />
      </Routes>
    );
  }

  return (
    <div className="userpanel">
      {!hideHeaderFooter && <Header />}
      {/* <GamingCursor /> */}
      {/* <Suspense fallback={<Loader />}> */}
        <Routes>
          <Route path='/' element={<Home />}> </Route>
          <Route path='/login' element={<Login />}> </Route>
          <Route path='/maintenance' element={<Maintenance />}> </Route>
          <Route path='/games' element={<Products />}> </Route>
          <Route path='/platforms' element={<Platforms />}> </Route>
          <Route path='/gamedetails/:slug' element={<GameDetails />}> </Route>
          <Route path='/bundles' element={<Bundles />}> </Route>
          <Route path='/contact' element={<Contact />}> </Route>
          <Route path='/cart' element={<Cart />}> </Route>
          <Route path='/wishlist' element={<Wishlist />}> </Route>
          <Route path='/about' element={<About />}> </Route>
          <Route path='/blog' element={<Blog />}> </Route>
          <Route path="/termsCondition" element={<TermsCondition />}></Route>
          <Route path="/privacyPolicy" element={<PrivacyPolacy />}></Route>
          <Route path="/Faq" element={<Faqs />}></Route>
          <Route path="/discount/:discountId/games" element={<DiscountGamesPage />} />
          <Route path='/profile' element={<Profile />}>
            <Route path="edit-profile" element={<EditProfile />} />
            <Route path="delete" element={<DeleteAccount />} />
            <Route path="orders" element={<Orders />} />
            <Route path="downloads" element={<Downloads />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      {/* </Suspense> */}
      {!hideHeaderFooter && <Footer />}
      <AttractiveScrollButton />
      {!hideHeaderFooter && <ChatWidget onStateChange={setIsChatOpen} />}
    </div>
  );
};

export default UserRouts;